window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, priority = 5, callback) => {
    window.bssB2BHooks.actions[tag] = window.bssB2BHooks.actions[tag] || [];
    window.bssB2BHooks.actions[tag][priority] = window.bssB2BHooks.actions[tag][priority] || [];
    window.bssB2BHooks.actions[tag][priority].push(callback);
}
window.BSS_B2B.addFilter = (tag, priority = 5, value) => {
    window.bssB2BHooks.filters[tag] = window.bssB2BHooks.filters[tag] || [];
    window.bssB2BHooks.filters[tag][priority] = window.bssB2BHooks.filters[tag][priority] || [];
    window.bssB2BHooks.filters[tag][priority].push(value);
}
function fixSearchBarCP5252(shopData) {
    let searchResult = document.querySelector('form.search-bar .search-bar__inner .search-bar__results-inner');
    if (searchResult) {
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.addedNodes.length) {
                    setTimeout(() => {
                        window.BSS_B2B.cp.changeProductPrice(
                            shopData,
                            '.search-bar__result-item .search-bar__item-info .search-bar__item-price',
                            false
                        );
                    }, 1500)
                }
            });
        });
        observer.observe(searchResult, {childList: true});
    }
}

window.BSS_B2B.addAction(`price_search_bar`, 0, fixSearchBarCP5252)
const getQtyTableHtml = function(
    shopData,
    appliedRule,
    quantityValue,
    isEnableMC,
    isEnabledTD,
    isQOPage = false,
    isShow = true
) {
    let rateMarket = Shopify.currency.rate;
    let productPrice = appliedRule.price;
    let qbTableType = appliedRule.qb_table_type;
    let buyText = BSS_B2B.qbTranslations.buy;
    let buttonUpDownQuantity = '<button class="bss-b2b-up-down-qb-btn" style="background: transparent; border: none; float: right; color: ' +
        window.BSS_B2B.qbSettings.text_header_table_color + '">&#x2193;</button>';
    if (window.BSS_B2B.page.isProductPage()) {
        buttonUpDownQuantity = '';
    }
    if (!productPrice) {
        productPrice =  BSS_B2B.qb.getAppliedRuleOnProductPage(false).price;
    }
    const checkLength = (i, qtyTableLength) => {
        if (i === qtyTableLength - 1) {
            return true;
        }
            return false;
        };
    let taxable = appliedRule.taxable ? appliedRule.taxable : false;
    let appliedTaxDisplayRule = null;
    if (isEnabledTD && window.BSS_B2B.taxDisplayRules && (window.BSS_B2B.taxDisplayRules.length > 0)) {
        if (window.BSS_B2B.page.isProductPage()) {
            appliedTaxDisplayRule = window.BSS_B2B.td.getAppliedRule(window.BSS_B2B, shopData);
        }
        else {
            appliedTaxDisplayRule = window.BSS_B2B.td.getAppliedRuleCartPage(window.BSS_B2B, shopData);
        }
    }
    let taxDisplayConditions = appliedTaxDisplayRule;
    // Quantity Break
    if (appliedRule.rule_setting === 0) {
        let qtyTable = appliedRule.qty_table;
        qtyTable.sort((a, b) => {
            return a.id - b.id;
        });
        const appliedSpecificPriceRule = qtyTable.filter((item) => {
                return item.discount_type === 0;
            });
            const decreasePriceRule = qtyTable.filter((item) => {
                return item.discount_type !== 0;
            });
        let table = '<table>';
        let textTotal = BSS_B2B.qbTranslations.total || 'Total';
        let tableDiscountText = window.BSS_B2B.qbTranslations.table_discount_text;
        let tableAppliedPriceText = window.BSS_B2B.qbTranslations.price_applied;
        let tableMinimumQuantity = BSS_B2B.qbTranslations.minimum_quantity;
        let tableMaximumQuantity = BSS_B2B.qbTranslations.maximum_quantity;
        let perItemTxtSpan = '<span class="bss-b2b-translation-qb-flat_price_suffix">' +
                BSS_B2B.qbTranslations.flat_price_suffix + '</span>';
        let textOff = BSS_B2B.qbTranslations.off;
        let textFor = BSS_B2B.qbTranslations.for;
        let blankCell = '<td class=\'bss-qty-blank-cell\' style=\'text-align:center;\'>---</td>';
        if (qbTableType !== null && !isQOPage) {
                switch (qbTableType) {
                    case 0:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_qty_range_text + '</th><th>' +
                            tableDiscountText + '</th>'+
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 1:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th>' + '<th>' + tableDiscountText + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 2:
                        table += '<thead><tr><th>' + tableMinimumQuantity + '</th><th>' + tableMaximumQuantity +
                            '</th>' + '<th>' + tableAppliedPriceText + '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 3:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 4:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 5:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableDiscountText + '</th>' +
                           '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 6:
                        table += '<tbody>';
                        break;
                    case 7:
                        if ((appliedSpecificPriceRule.length && decreasePriceRule.length)) {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                '</th>' + '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                            table += '<tbody>';
                        }
                        else if (decreasePriceRule.length) {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                '</th>' +
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                            table += '<tbody>';
                        }
                        else {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th></tr></thead>';
                            table += '<tbody>';
                        }
                        break;
                    case 8:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_qty_range_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 9:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th>' + '<th>' + textTotal + '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    default:
                        break;
                }
            }
      for (let i = 0; i < qtyTable.length; i++) {
                let discountValue = qtyTable[i].discount_value;
                let quantityFrom = qtyTable[i].qty_from;
                let priceValue = null;
                let finalPriceAfterPercentageDiscount = 0;
                let newProductPrice = productPrice;
                let realDiscount = 0;
                let isShowTextPerItem = qtyTable[i].discount_type === 0 || !isQOPage;
                let discountRuleType = qtyTable[i].discount_type;
                let total = null;
                switch (qtyTable[i].discount_type) {
                    case 0:
                        realDiscount = (productPrice / (100 * rateMarket) - discountValue).toFixed(2);
                        realDiscount = (realDiscount * rateMarket).toFixed(2);
                        discountValue = productPrice / 100 - realDiscount;
                        if (taxDisplayConditions) {
                            priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue * 100,
                                appliedTaxDisplayRule, taxable, shopData);
                            total = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                discountValue * quantityFrom * 100, appliedTaxDisplayRule, taxable, shopData);
                            discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                appliedRule.price - discountValue * 100, appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                total = BSS_B2B.MC.convertPriceByMc(discountValue * quantityFrom * 100, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(discountValue * 100);
                                total = BSS_B2B.formatMoney(discountValue * 100 * quantityFrom);
                                discountValue = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? appliedRule.price - discountValue *
                                        100 : discountValue * 100 - appliedRule.price);
                            }
                        }
                        break;
                    case 1:
                        if (!isQOPage) {
                            discountValue = BSS_B2B.helper.convertPriceWithRate(discountValue);
                            discountValue = appliedRule.price - discountValue * 100;
                            if (discountValue > 0) {
                                if (taxDisplayConditions) {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    total = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        discountValue * quantityFrom, appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        qtyTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(discountValue, false);
                                        total = BSS_B2B.MC.convertPriceByMc(discountValue * quantityFrom, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(qtyTable[i].discount_value * 100,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(discountValue);
                                        total = BSS_B2B.formatMoney(discountValue * quantityFrom);
                                        discountValue = BSS_B2B.formatMoney(
                                            qtyTable[i].discount_value * 100 * rateMarket);
                                    }
                                }
                            }
                            else {
                                if (taxDisplayConditions) {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    total = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(0, false);
                                        total = BSS_B2B.MC.convertPriceByMc(0, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price, false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(0);
                                        total = BSS_B2B.formatMoney(0);
                                        discountValue = BSS_B2B.formatMoney(appliedRule.price);
                                    }
                                }
                            }
                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                                total = BSS_B2B.MC.convertPriceByMc(
                                    (appliedRule.price - discountValue * 100) * quantityFrom, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? appliedRule.price - discountValue *
                                        100 : discountValue * 100 - appliedRule.price);
                                total = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? (appliedRule.price - discountValue *
                                        100) * quantityFrom : (discountValue * 100 - appliedRule.price) * quantityFrom);
                                discountValue = BSS_B2B.formatMoney(discountValue * 100);
                            }
                        }
                        break;
                    case 2:
                        realDiscount = ((productPrice / rateMarket) * ((discountValue) / 100)).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newProductPrice = productPrice - realDiscount;
                        if (taxDisplayConditions) {
                            finalPriceAfterPercentageDiscount = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice, appliedTaxDisplayRule, taxable, shopData);
                            total = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice * quantityFrom, appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                finalPriceAfterPercentageDiscount = BSS_B2B.MC.convertPriceByMc((newProductPrice),
                                    false);
                                total = BSS_B2B.MC.convertPriceByMc((newProductPrice) * quantityFrom, false);
                            }
                            else {
                                finalPriceAfterPercentageDiscount = BSS_B2B.formatMoney(newProductPrice);
                                total = BSS_B2B.formatMoney((newProductPrice) * quantityFrom);
                            }
                        }
                    
                        if (!isQOPage) {
                            priceValue = finalPriceAfterPercentageDiscount;
                            discountValue = discountValue + '%';
                        }
                        break;
                    default:
                        break;
                }
            let rowIsApplyRule = false;
                if (quantityValue) {
                    if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                        if (quantityValue >= qtyTable[i].qty_from) {
                            rowIsApplyRule = true;
                        }
                    }
                    else {
                        if (quantityValue >= qtyTable[i].qty_from && qtyTable[i].qty_to >= quantityValue) {
                            rowIsApplyRule = true;
                        }
                    }
                }
                let qtyRange = '<td>' + qtyTable[i].qty_from + ' - ' + qtyTable[i].qty_to + '</td>';
                let qtyTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (rowIsApplyRule ? ('qty-row-active') : '') +
                    '\' data-min=\'' + qtyTable[i].qty_from + '\' data-max=\'' + qtyTable[i].qty_to + '\'>';
                let qtyTo = `${qtyTable[i].qty_to}`;
                if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                        qtyRange = '<td> ≥ ' + qtyTable[i].qty_from + '</td>';
                    qtyTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (rowIsApplyRule ? ('qty-row-active') : '') +
                        '\' data-min=\'' + qtyTable[i].qty_from + '\' data-max=\'' + qtyTable[i].qty_from + '\'>';
                    if ([0, 2, 7, 8].indexOf(qbTableType) !== -1) {
                        if (qbTableType === 2) {
                            qtyTo = qtyTable[i].qty_from + '+';
                        }
                        else {
                            qtyTo = '≥' + qtyTable[i].qty_from;
                        }
                    }
                }
                if ([1, 4, 5, 9].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + buyText + ' ' + qtyTable[i].qty_from +
                            '</td>';
                    }
                    else {
                        qtyRange = '<td>' + buyText + ' ' + qtyTable[i].qty_from + '</td>';
                    }
                }
                else if ([2, 3].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTable[i].qty_from + '</td>';
                    }
                    else {
                        qtyRange = '<td>' + qtyTable[i].qty_from + '</td>';
                    }
                }
                else if ([6].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' +
                            qtyTable[i].qty_from + ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' +
                            textOff + ')' + '</td>';
                    }
                    else {
                        qtyRange = '<td>' + buyText + ' ' + qtyTable[i].qty_from + ' ' + textFor + ' ' + priceValue +
                            ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                    }
                }
                else {
                    qtyRange = '<td>' + qtyTable[i].qty_from + ' - ' + qtyTo + '</td>';
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTable[i].qty_from + ' - ' + qtyTo +
                            '</td>';
                        if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                            qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTo + '</td>';
                        }
                    }
                }
                table += qtyTableRow;
                table += qtyRange;
                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                               table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                               table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 1:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 2:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + qtyTo + '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + qtyTable[i].qty_to + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 3:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + '</td>';
                            }
                            break;
                        case 4:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 5:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                               table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                               table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                            }
                            break;
                        case 7:
                            if (appliedSpecificPriceRule.length && decreasePriceRule.length ) {
                                if (discountRuleType === 0) {
                                    table += blankCell;
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                      table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                      table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                }
                                else {
                                    table += '<td>' + discountValue + '</td>';
                                        if (checkLength(i, qtyTable.length)) {
                                            table += '<td class=\'bss-qty-blank-cell border-radius-right-table-qb\' style=\'text-align:center;\'>---</td>';
                                           table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                        }
                                        else {
                                            table += blankCell;
                                           table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                        }
                                }
                            }
                            else {
                                if (discountRuleType === 0) {
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                       table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                      table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                }
                                else {
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + discountValue +
                                            '</td>';
                                       table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                    else {
                                        table += '<td>' + discountValue + '</td>';
                                       table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                    }
                                }
                            }
                            break;
                        case 8:
                        
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                              
                            }
                            else {
                                table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                                
                            }
                            break;
                        case 9:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + total + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td>' + total + '</td>';
                            }
                            break;
                        default:
                            break;
                    }
                } else {
                    table += '<td>' + discountValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                }
                table += '</tr>';
            }
            table += '</tbody>';
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table">';
            if (BSS_B2B.storeId !== 2650 || (BSS_B2B.storeId === 2650 && BSS_B2B.page.isProductPage())) {
                details += '<p class="bss-b2b-cart-item-qty-table-header-title" style="margin-top: 1rem; margin-bottom: 0.2rem;"><span style="width: 95%; font-weight: 700; font-size: 1.2rem;">' +
                    appliedRule.name + '</span></p>';
                if (buttonUpDownQuantity) {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 95%;">' +
                        BSS_B2B.qbTranslations.table_header_text + '</span>';
                    details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
                }
                else {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 100%;">' +
                        BSS_B2B.qbTranslations.table_header_text + '</span>';
                }
                details += '</p>';
                details += '<div class="bss-b2b-qty-table-wrapper"' +
                    (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            }
            details += '</div>';
            setTimeout(() => {
                BSS_B2B.integrate.langShop.handleAllTranslation('qb', ['rule_name'], appliedRule.name);
            }, 100);
            return details;
    }
    // Amount Break
    else {
        let amountTable = appliedRule.amount_table;
            amountTable.sort((a, b) => {
                return a.id - b.id;
            });
            const appliedSpecificPriceRule = amountTable.filter((item) => {
                return item.discount_type === 0;
            });
            const decreasePriceRule = amountTable.filter((item) => {
                return item.discount_type !== 0;
            });
            let table = '<table class="quantity_break_table">';
            let tableDiscountText = BSS_B2B.qbTranslations.table_discount_text;
            let tableAppliedPriceText = BSS_B2B.qbTranslations.price_applied;
            let tableMinimumAmount = BSS_B2B.qbTranslations.minimum_amount;
            let tableMaximumAmount = BSS_B2B.qbTranslations.maximum_amount;
            let textOff = BSS_B2B.qbTranslations.off;
            let textFor = BSS_B2B.qbTranslations.for;
            let perItemTxtSpan = '<span class="bss-b2b-translation-qb-flat_price_suffix">' +
                BSS_B2B.qbTranslations.flat_price_suffix + '</span>';
            if (!isQOPage) {
                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                             table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_amount_range_text + '</th><th>' +
                                tableDiscountText + '</th>' +
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                            table += '<tbody>';
                             break
                        case 1:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '<th>' + tableDiscountText + '</th>' +
                                '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 2:
                        
                            table += '<thead><tr><th>' + tableMinimumAmount + '</th><th>' + tableMaximumAmount +
                                '</th>' + '<th>' + tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 3:
                       
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 4:
                        
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 5:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableDiscountText + '</th>' +
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 7:
                            if ((appliedSpecificPriceRule.length && decreasePriceRule.length) || BSS_B2B.storeId ===
                                4088) {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text +
                                    '</th><th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                    '</th>' + '<th class="bss-b2b-translation-qb-price_applied">' +
                                    tableAppliedPriceText + '</th>' + '</tr></thead>';
                                table += '<tbody>';
                            }
                            else if (decreasePriceRule.length) {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text +
                                    '</th><th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                    '</th>'+
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' +'</tr></thead>';
                                table += '<tbody>';
                            }
                            else {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text + '</th>' +
                                    '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                    '</th>'+
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' +'</tr></thead>';
                                table += '<tbody>';
                            }
                            break;
                        case 8:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_amount_range_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        default:
                            break;
                    }
                }
                else {
                    //do thing
                }
            }
       for (let i = 0; i < amountTable.length; i++) {
                let discountValue = amountTable[i].discount_value;
                let priceValue = null;
                let finalPriceAfterPercentageDiscount = 0;
                let newProductPrice = productPrice;
                let realDiscount = 0;
                let isShowTextPerItem = amountTable[i].discount_type === 0 ||
                    ([7, 8].indexOf(qbTableType) !== -1 && !isQOPage);
                let discountRuleType = amountTable[i].discount_type;
                let blankCell = '<td class=\'bss-qty-blank-cell\' style=\'text-align:center;\'>---</td>';
                switch (amountTable[i].discount_type) {
                    case 0:
                        realDiscount = (productPrice / (100 * rateMarket) - discountValue).toFixed(2);
                        realDiscount = (realDiscount * rateMarket).toFixed(2);
                        discountValue = productPrice / 100 - realDiscount;
                        if (taxDisplayConditions) {
                            priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue * 100,
                                appliedTaxDisplayRule, taxable, shopData);
                            discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                (appliedRule.price - discountValue * 100), appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(discountValue * 100);
                                discountValue = BSS_B2B.formatMoney(appliedRule.price - discountValue * 100);
                            }
                        }
                        break;
                    case 1:
                        if (!isQOPage) {
                            discountValue = BSS_B2B.helper.convertPriceWithRate(discountValue);
                            discountValue = appliedRule.price - discountValue * 100;
                            if (discountValue > 0) {
                                if (taxDisplayConditions) {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        amountTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(discountValue, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(amountTable[i].discount_value * 100,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(discountValue);
                                        discountValue = BSS_B2B.formatMoney(amountTable[i].discount_value * 100);
                                    }
                                }
                            }
                            else {
                                if (taxDisplayConditions) {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = discountValue = BSS_B2B.MC.convertPriceByMc(0, false);
                                        discountValue = discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(0);
                                        discountValue = BSS_B2B.formatMoney(appliedRule.price);
                                    }
                                }
                            }
                        }
                        else {
                            if (taxDisplayConditions) {
                                discountValue = appliedRule.price - discountValue * 100;
                                if (discountValue) {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        amountTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    priceValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                            }
                            else {
                                if (isEnableMC) {
                                    priceValue = BSS_B2B.MC.convertPriceByMc(
                                        appliedRule.price - amountTable[i].discount_value * 100, false);
                                    discountValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                }
                                else {
                                    priceValue = BSS_B2B.formatMoney(appliedRule.price - discountValue * 100);
                                    discountValue = BSS_B2B.formatMoney(discountValue * 100);
                                }
                            }
                        }
                        break;
                    case 2:
                        realDiscount = ((productPrice / rateMarket) * ((discountValue) / 100)).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newProductPrice = productPrice - realDiscount;
                        if (taxDisplayConditions) {
                            finalPriceAfterPercentageDiscount = window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice, appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                finalPriceAfterPercentageDiscount = BSS_B2B.MC.convertPriceByMc(newProductPrice, false);
                            }
                            else {
                                finalPriceAfterPercentageDiscount = BSS_B2B.formatMoney(newProductPrice);
                            }
                        }
                        if (!isQOPage) {
                            discountValue = discountValue + '%';
                            priceValue = finalPriceAfterPercentageDiscount;
                        }
                        break;
                    default:
                        break;
                }
                // fix for b2b-vapeholster.myshopify.com by LuanHV
                let activeRow = false;
                if (quantityValue) {
                    if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                        if (quantityValue * appliedRule.price >= amountTable[i].amount_from * 100) {
                            activeRow = true;
                        }
                    }
                    else {
                        if (quantityValue * appliedRule.price >= amountTable[i].amount_from * 100 &&
                            amountTable[i].amount_to * 100 >= quantityValue * appliedRule.price) {
                            activeRow = true;
                        }
                    }
                }

                let amountFrom = isEnableMC ? BSS_B2B.MC.convertPriceByMc((Number(amountTable[i].amount_from) * 100),
                    false) : BSS_B2B.formatMoney(Number(amountTable[i].amount_from * rateMarket) * 100);
                let amountTo = isEnableMC
                    ? BSS_B2B.MC.convertPriceByMc((Number(amountTable[i].amount_to) * 100), false)
                    : BSS_B2B.formatMoney(Number(amountTable[i].amount_to * rateMarket) * 100);

                let amountRange = '<td>' + amountFrom + ' - ' + amountTo + '</td>';
                let amountTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (activeRow ? ('qty-row-active') : '') +
                    '\' data-min=\'' + amountTable[i].amount_from + '\' data-max=\'' + amountTable[i].amount_to + '\'>';
                if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                    if (qbTableType === 2) {
                        amountTo = amountFrom + '+';
                    }
                    amountRange = '<td> ≥ ' + amountFrom + '</td>';
                    amountTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (activeRow ? ('qty-row-active') : '') +
                        '\' data-min=\'' + amountTable[i].amount_from + '\' data-max=\'' + amountTable[i].amount_from +
                        '\'>';
                }
                if ([1, 4, 5].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-table-qb\'>' + buyText + ' ' + amountFrom +'</td>';
                    }
                    else {
                        amountRange = '<td>' + buyText + ' ' + amountFrom + '</td>';
                    }
                }
                else if ([2, 3].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-table-qb\'>' + amountFrom + '</td>';
                    }
                    else {
                        amountRange = '<td>' + amountFrom + '</td>';
                    }
                }
                else if ([6].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' + amountFrom +
                            ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                    }
                    else {
                        amountRange = '<td>' + buyText + ' ' + amountFrom + ' ' + textFor + ' ' + priceValue + ' (' +
                            discountValue + ' ' + textOff + ')' + '</td>';
                    }
                }
                else {
                    if (checkLength(i, amountTable.length)) {
                        if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + '≥' + amountFrom +'</td>';
                        }
                        else {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + amountFrom + ' - ' + amountTo + '</td>';
                        }
                    }
                }

                if (taxDisplayConditions) {
                    amountRange = '<td>' +
                    BSS_B2B.td.changeVatPriceOnABRange(appliedRule.keyOrId, Number(amountTable[i].amount_from * 100),
                            Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    if ([1, 4, 5].indexOf(qbTableType) !== -1) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText +
                            window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable,
                                    shopData) + '</td>';
                        }
                        else {
                            amountRange = '<td>' + buyText + window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable, shopData) +
                                '</td>';
                        }
                    }
                    else if ([2, 3].indexOf(qbTableType) !== -1) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' +
                                window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable,
                                    shopData) + '</td>';
                        }
                        else {
                            amountRange = '<td>' + window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable, shopData) +
                                '</td>';
                        }
                    }
                    else if (qbTableType === 6) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' +
                            window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) +
                                ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                        }
                        else {
                            amountRange = '<td>' + buyText + ' ' +
                            window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) +
                                ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                        }
                    }
                }
                table += amountTableRow;
                table += amountRange;
                if (qbTableType === 2 && taxDisplayConditions) {
                    if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                        table += '<td>' + BSS_B2B.td.changeVatPriceOnABRange(appliedRule.keyOrId,
                            Number(amountTable[i].amount_from * 100), Number(amountTable[i].amount_to * 100),
                            appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    }
                    else {
                        table += '<td>' + window.BSS_B2B.td.changeVatPriceOnQBABTable(appliedRule.keyOrId,
                            Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    }
                }

                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }
                            break;
                        case 1:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 2:
                            if (checkLength(i, amountTable.length)) {
                                if (!taxDisplayConditions) {
                                    table += '<td>' + amountTo + '</td>';
                                }
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue + '</td>';
                            }
                            else {
                                if (!taxDisplayConditions) {
                                    table += '<td>' + amountTo + '</td>';
                                }
                                table += '<td>' + priceValue + '</td>';
                            }

                            break;
                        case 3:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +(' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }

                            break;
                        case 4:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +(' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }
                            break;
                        case 5:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                            }
                            break;
                        case 7:
                            if ((appliedSpecificPriceRule.length && decreasePriceRule.length) || BSS_B2B.storeId ===
                                4088) {
                                if (discountRuleType === 0) {
                                    table += blankCell;
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +(isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                }
                                else {
                                    table += '<td>' + discountValue + '</td>';
                                   
                                        if (checkLength(i, amountTable.length)) {
                                            table += '<td class=\'bss-qty-blank-cell border-radius-right-table-qb\' style=\'text-align:center;\'>---</td>';
                                            table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                        }
                                        else {
                                            table += blankCell;
                                            table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                        }
                                }
                            }
                            else {
                                if (discountRuleType === 0) {
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +(isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +(isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                }
                                else {
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + discountValue +'</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                    else {
                                        table += '<td>' + discountValue + '</td>';
                                        table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +'</td>';
                                    }
                                }
                            }
                            break;
                        case 8:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +(isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +'</td>';
                            }
                            break;
                        default:
                            break;
                    }
                }
                table += '</tr>';
                
            }
            table += '</tbody>';
            table += '</table>';
            let details = '<div class="bss-b2b-cart-item-qty-table">';
            if (BSS_B2B.storeId !== 2650 || (BSS_B2B.storeId === 2650 && BSS_B2B.page.isProductPage())) {
                details += '<p class="bss-b2b-cart-item-qty-table-header-title" style="margin-top: 1rem; margin-bottom: 0.2rem;"><span style="width: 95%; font-weight: 700; font-size: 1.2rem;">' +
                    appliedRule.name + '</span></p>';
                if (buttonUpDownQuantity) {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 95%;" class="bss-b2b-translation-qb-table_header_text_ab">' +
                        BSS_B2B.qbTranslations.table_header_text_ab + '</span>';
                    details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
                }
                else {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 100%;" class="bss-b2b-translation-qb-table_header_text_ab">' +
                        BSS_B2B.qbTranslations.table_header_text_ab + '</span>';
                }
                details += '<div class="bss-b2b-qty-table-wrapper"' +
                    (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            }
            details += '</div>';
            setTimeout(() => {
                BSS_B2B.integrate.langShop.handleAllTranslation('qb', ['rule_name'], appliedRule.name);
            }, 100);
            return details;  
    }
};

window.BSS_B2B.addFilter(`qb_generate_table`, 0, getQtyTableHtml);